/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthSmsRequest } from '../../models/auth-sms-request';
import { CoolDownTimeResponse } from '../../models/cool-down-time-response';

export interface AuthUserWithPhoneNumber$Params {

/**
 * uuid key of the tenant
 */
  'X-Tenant-Key'?: string;
      body: AuthSmsRequest
}

export function authUserWithPhoneNumber(http: HttpClient, rootUrl: string, params: AuthUserWithPhoneNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<CoolDownTimeResponse>> {
  const rb = new RequestBuilder(rootUrl, authUserWithPhoneNumber.PATH, 'post');
  if (params) {
    rb.header('X-Tenant-Key', params['X-Tenant-Key'], {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CoolDownTimeResponse>;
    })
  );
}

authUserWithPhoneNumber.PATH = '/api/v1/auth/user/phone_number';
